'use strict';

declare var loadMarketComponent: any;

module Patersons {


    export interface CompanyResearchScope extends ng.IScope {
        events: Patersons.CompanyResearchCtrl;
        isLoading: boolean;
    }

    export class CompanyResearchCtrl extends ResearchBaseCtrl {
        scope: Patersons.CompanyResearchScope;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
        }
    }
}
